"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersClient = void 0;
const client_1 = require("@leid/client");
class OrdersClient extends client_1.ClientBase {
    /* LAMBDA METHODS */
    async processOrderPayment(id, request) {
        try {
            const response = await this.httpClient.put(`/orders/${id}/payment`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'processOrderPayment error on a call', id, request);
        }
    }
    async triggerOrderCompleteEmails(orderId) {
        try {
            const response = await this.httpClient.post(`/orders/${orderId}/order-complete-emails`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerOrderCompleteEmails error on a call', orderId);
        }
    }
    async triggerOrderCompleteSegmentEvent(orderId) {
        try {
            const response = await this.httpClient.post(`/orders/${orderId}/order-complete-segment`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerOrderCompleteSegmentEvent error on a call', orderId);
        }
    }
    async triggerScheduledReminder(orderId, orderItemIds, emailType) {
        try {
            const body = {
                orderItemIds,
                emailType,
            };
            const response = await this.httpClient.post(`/orders/${orderId}/scheduled-emails`, body);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerScheduledReminder error on a call', orderId, orderItemIds, emailType);
        }
    }
    async triggerCanceledEmail(orderId, orderItemIds) {
        try {
            const body = {
                orderItemIds,
            };
            const response = await this.httpClient.post(`/orders/${orderId}/canceled-email`, body);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerCanceledEmail error on a call', orderId, orderItemIds);
        }
    }
    async triggerOrderCompleteSms(orderId) {
        try {
            const response = await this.httpClient.post(`/orders/${orderId}/order-complete-sms`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerOrderCompleteSms error on a call', orderId);
        }
    }
    async getOrderItemsForReminders(orderId, type) {
        try {
            const response = await this.httpClient.get(`/orders/${orderId}/order-items/${type}/reminders/`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderItemsForReminders error on a call', orderId, type);
        }
    }
    async checkActiveOrderItemsForReminders(orderId, orderItemIds, type) {
        try {
            const params = { orderItemIds };
            const response = await this.httpClient.get(`/orders/${orderId}/order-items/${type}/reminders/check`, {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'checkActiveOrderItemsForReminders error on a call', orderId, orderItemIds, type);
        }
    }
    /* ORDERS */
    async getOrders(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/orders', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrders error on a call', filter, sortingData);
        }
    }
    async getOrder(id) {
        try {
            const response = await this.httpClient.get(`/orders/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrder error on a call', id);
        }
    }
    async createOrder(request) {
        try {
            const response = await this.httpClient.post('/orders', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createOrder error on a call', request);
        }
    }
    async updateOrder(id, request) {
        try {
            const response = await this.httpClient.put(`/orders/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateOrder error on a call', id);
        }
    }
    async cancelOrder(id, request) {
        try {
            const response = await this.httpClient.put(`/orders/${id}/cancel`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'cancelOrder error on a call', id);
        }
    }
    async getOrdersReport(from, to) {
        try {
            const response = await this.httpClient.get('/orders/report', {
                params: { from, to },
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrdersReport error on a call', from, to);
        }
    }
    async getOrderAvailabilityInfo(id) {
        try {
            const response = await this.httpClient.get(`/orders/${id}/availability`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderAvailabilityInfo error on a call', id);
        }
    }
    async initiateManualOrder(id, paymentMethod) {
        try {
            const response = await this.httpClient.post(`/orders/${id}/manual/initiate`, {
                paymentMethod,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'initiateManualOrder error on a call', id);
        }
    }
    /* BOOTSTRAP */
    async bootstrapProlongationOrder(request) {
        try {
            const response = await this.httpClient.post('/bootstrap/prolongations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'bootstrapProlongationOrder error on a call', request);
        }
    }
    async bootstrapReconciliationOrder(request) {
        try {
            const response = await this.httpClient.post('/bootstrap/reconciliations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'bootstrapReconciliationOrder error on a call', request);
        }
    }
    async bootstrapOfferOrderProlongation(request) {
        try {
            const response = await this.httpClient.post('/bootstrap/offer-orders/prolongations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'bootstrapOfferOrderProlongation error on a call', request);
        }
    }
    /* ORDER ITEMS */
    async getOrderItems(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/order-items', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderItems error on a call', filter, sortingData);
        }
    }
    async getOrderItem(id) {
        try {
            const response = await this.httpClient.get(`/order-items/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderItem error on a call', id);
        }
    }
    async createOrderItem(request) {
        try {
            const response = await this.httpClient.post('/order-items', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createOrderItem error on a call', request);
        }
    }
    async updateOrderItem(id, request) {
        try {
            const response = await this.httpClient.put(`/order-items/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateOrderItem error on a call', id, request);
        }
    }
    async cancelOrderItem(id, request) {
        try {
            const response = await this.httpClient.put(`/order-items/${id}/cancel`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'cancelOrderItem error on a call', id);
        }
    }
    async deleteOrderItem(id) {
        try {
            const response = await this.httpClient.delete(`/order-items/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteOrderItem error on a call', id);
        }
    }
    async setPickupReason(request) {
        try {
            const response = await this.httpClient.put(`/orders/${request.orderId}/order-items/pickup-reason`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setPickupReason error on a call', request);
        }
    }
    async setReturnReason(request) {
        try {
            const response = await this.httpClient.put(`/orders/${request.orderId}/order-items/return-reason`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setReturnReason error on a call', request);
        }
    }
    async setCompletedReason(request) {
        try {
            const response = await this.httpClient.put(`/orders/${request.orderId}/order-items/completed-reason`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setReturnReason error on a call', request);
        }
    }
    async setAssetId(request) {
        try {
            const response = await this.httpClient.put(`/order-items/${request.orderItemId}/asset-id`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setAssetId error on a call', request);
        }
    }
    async setPickupStatus(request) {
        try {
            const response = await this.httpClient.put(`/orders/${request.orderId}/order-items/pickup-status`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setPickupStatus error on a call', request);
        }
    }
    async setOrderItemPriceManually(id, request) {
        try {
            const response = await this.httpClient.put(`/order-items/${id}/price`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setOrderItemPriceManually error on a call', request);
        }
    }
    async changeOrderItemAmount(id, request) {
        try {
            const response = await this.httpClient.patch(`/order-items/${id}/amount`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'changeOrderItemAmount error on a call', id, request);
        }
    }
    async getOrderItemProlongationPrice(id, request) {
        try {
            const response = await this.httpClient.get(`/order-items/${id}/prolongation-price`, { params: request });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderItemProlongationPrice error on a call', id, request);
        }
    }
    /* CALENDAR */
    async getCalendarList(productId, request) {
        try {
            const response = await this.httpClient.get(`/products/${productId}/calendar-list`, { params: request });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCalendarList error on a call', productId, request);
        }
    }
    /* SUM METHODS */
    async getOrderItemSum(id) {
        try {
            const response = await this.httpClient.get(`/order-items/sum/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderItemSum error on a call', id);
        }
    }
    async getOrderItemsSum(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/order-items/sum', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderItemsSum error on a call', filter, sortingData);
        }
    }
    async getOrderSum(id) {
        try {
            const response = await this.httpClient.get(`/orders/sum/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrderSum error on a call', id);
        }
    }
    async getOrdersSum(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/orders/sum', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrdersSum error on a call', filter, sortingData);
        }
    }
    /* PRODUCTS METHODS */
    async getProductPrice(id, request) {
        try {
            const response = await this.httpClient.get(`/products/${id}/get-price`, { params: request });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductPrice error on a call', id, request);
        }
    }
    async getProductPriceWithPricingBase(id, request) {
        try {
            const response = await this.httpClient.post(`/products/${id}/get-price-with-pricing-base`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductPriceWithPricingBase error on a call', id, request);
        }
    }
    async checkProductAvailability(productId, request) {
        try {
            const response = await this.httpClient.get(`/products/${productId}/available`, { params: request });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'checkProductAvailability error on a call', productId, request);
        }
    }
    /* PAYMENT STATUSES METHODS */
    async getPaymentStatuses(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/payment-status', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPaymentStatuses error on a call', filter, sortingData);
        }
    }
    /* RERENT ORDERS METHODS */
    async createRerentOrder(request) {
        try {
            const response = await this.httpClient.post('/rerent-orders', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createRerentOrder error on a call', request);
        }
    }
    async getOrCreateReconciliationRequest(request) {
        try {
            const response = await this.httpClient.put('/rerent-orders/reconciliations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrCreateReconciliationRequest error on a call', request);
        }
    }
    async updateRerentOrder(id, request) {
        try {
            const response = await this.httpClient.put(`/rerent-orders/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateRerentOrder error on a call', id, request);
        }
    }
    async getRerentOrders(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/rerent-orders', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRerentOrders error on a call', filter, sortingData);
        }
    }
    async getRerentOrder(id) {
        try {
            const response = await this.httpClient.get(`/rerent-orders/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRerentOrder error on a call', id);
        }
    }
    async declineRerentOrder(id, request) {
        try {
            const response = await this.httpClient.put(`/rerent-orders/${id}/decline`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'declineRerentOrder error on a call', id, request);
        }
    }
    async reopenRerentOrder(id) {
        try {
            const response = await this.httpClient.put(`/rerent-orders/${id}/reopen`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'reopenRerentOrder error on a call', id);
        }
    }
    async completeRerentOrder(id) {
        try {
            const response = await this.httpClient.put(`/rerent-orders/${id}/complete`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'completeRerentOrder error on a call', id);
        }
    }
    async approveRerentOrder(id, paymentMethod) {
        try {
            const response = await this.httpClient.put(`/rerent-orders/${id}/approve`, {
                paymentMethod,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'approveRerentOrder error on a call', id);
        }
    }
    async checkRerentOrderOnCustomerRegistration(request) {
        try {
            const response = await this.httpClient.post('/rerent-orders/check-on-registration', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'checkRerentOrderOnCustomerRegistration error on a call', request);
        }
    }
    async inviteCustomerToRegisterForRerentOrder(rerentOrderId) {
        try {
            const response = await this.httpClient.post(`/rerent-orders/${rerentOrderId}/invitations`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'inviteCustomerToRegisterForRerentOrder error on a call', rerentOrderId);
        }
    }
    /* RERENT ORDER ITEMS METHODS */
    async createRerentOrderItem(request) {
        try {
            const response = await this.httpClient.post('/rerent-order-items', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createRerentOrderItem error on a call', request);
        }
    }
    async updateRerentOrderItem(id, request) {
        try {
            const response = await this.httpClient.put(`/rerent-order-items/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateRerentOrderItem error on a call', id, request);
        }
    }
    async getRerentOrderItems(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/rerent-order-items', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRerentOrderItems error on a call', filter, sortingData);
        }
    }
    async getRerentOrderItem(id) {
        try {
            const response = await this.httpClient.get(`/rerent-order-items/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRerentOrderItem error on a call', id);
        }
    }
    async approveRerentOrderItem(id) {
        try {
            const response = await this.httpClient.put(`/rerent-order-items/${id}/approve`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'approveRerentOrderItem error on a call', id);
        }
    }
    async declineRerentOrderItem(id) {
        try {
            const response = await this.httpClient.put(`/rerent-order-items/${id}/decline`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'declineRerentOrderItem error on a call', id);
        }
    }
    async openRerentOrderItem(id) {
        try {
            const response = await this.httpClient.put(`/rerent-order-items/${id}/open`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'openRerentOrderItem error on a call', id);
        }
    }
    async calculateRerentTotalPrice(customerId, request) {
        try {
            const response = await this.httpClient.get(`/rerent-order-items/price/${customerId}`, {
                params: request,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'calculateRerentTotalPrice error on a call', customerId, request);
        }
    }
    /* RERENT ORDER NOTES */
    async getRerentOrderNotes(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/rerent-order-notes', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRerentOrderNotes error on a call', filter, sortingData);
        }
    }
    async getRerentOrderNote(id) {
        try {
            const response = await this.httpClient.get(`/rerent-order-notes/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRerentOrderNote error on a call', id);
        }
    }
    async createRerentOrderNote(rerentOrderNote) {
        try {
            const response = await this.httpClient.post('/rerent-order-notes', rerentOrderNote);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createRerentOrderNote error on a call', rerentOrderNote);
        }
    }
    /* PDFs */
    async generateReceiptPDF(orderId) {
        try {
            const response = await this.httpClient.post(`/orders/${orderId}/pdfs/receipt`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'generateReceiptPDF error on a call', orderId);
        }
    }
    async generateInvoicePDF(orderId) {
        try {
            const response = await this.httpClient.post(`/orders/${orderId}/pdfs/invoice`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'generateInvoicePDF error on a call', orderId);
        }
    }
    /* OFFER ORDERS METHODS */
    async createOfferOrder(request) {
        try {
            const response = await this.httpClient.post('/offer-orders', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createOfferOrder error on a call', request);
        }
    }
    async updateOfferOrder(id, request) {
        try {
            const response = await this.httpClient.put(`/offer-orders/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateOfferOrder error on a call', id, request);
        }
    }
    async getOfferOrder(id) {
        try {
            const response = await this.httpClient.get(`/offer-orders/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOfferOrder error on a call', id);
        }
    }
    async getOfferOrders(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/offer-orders', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOfferOrders error on a call', filter, sortingData);
        }
    }
    async sendOfferOrder(id) {
        try {
            const response = await this.httpClient.post(`/offer-orders/${id}/send`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendOfferOrder error on a call', id);
        }
    }
    async triggerOfferOrderSend(request) {
        try {
            const response = await this.httpClient.post('/offer-orders/trigger-send', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerOfferOrderSend error on a call', request);
        }
    }
    async triggerOfferOrderResend(request) {
        try {
            const response = await this.httpClient.post('/offer-orders/trigger-resend', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'triggerOfferOrderResend error on a call', request);
        }
    }
    async decryptOfferOrderData(request) {
        try {
            const response = await this.httpClient.post('/offer-orders/decrypt', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'decryptOfferOrderData error on a call', request);
        }
    }
    async processOfferOrder(requestOrderId) {
        try {
            const response = await this.httpClient.post(`/offer-orders/process/request-orders/${requestOrderId}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'processOfferOrder error on a call', requestOrderId);
        }
    }
    async approveOfferOrder(requestOrderId) {
        try {
            const response = await this.httpClient.post(`/offer-orders/approve/request-orders/${requestOrderId}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'approveOfferOrder error on a call', requestOrderId);
        }
    }
    async completeOfferOrder(requestOrderId) {
        try {
            const response = await this.httpClient.post(`/offer-orders/complete/request-orders/${requestOrderId}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'completeOfferOrder error on a call', requestOrderId);
        }
    }
    /* OFFER ORDER ITEMS METHODS */
    async createOfferOrderItem(request) {
        try {
            const response = await this.httpClient.post('/offer-order-items', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createOfferOrderItem error on a call', request);
        }
    }
    async updateOfferOrderItem(id, request) {
        try {
            const response = await this.httpClient.put(`/offer-order-items/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateOfferOrderItem error on a call', id, request);
        }
    }
    async getOfferOrderItem(id) {
        try {
            const response = await this.httpClient.get(`/offer-order-items/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOfferOrderItem error on a call', id);
        }
    }
    async resetOfferOrderItem(id, request) {
        try {
            const response = await this.httpClient.put(`/offer-order-items/${id}/reset`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'resetOfferOrderItem error on a call', id, request);
        }
    }
    async getOfferOrderItems(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/offer-order-items', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOfferOrderItems error on a call', filter, sortingData);
        }
    }
    async selectOfferOrderItem(id, request) {
        try {
            const response = await this.httpClient.post(`/offer-order-items/${id}/select`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'selectOfferOrderItem error on a call', id, request);
        }
    }
    async declineOfferOrderItem(id, request) {
        try {
            const response = await this.httpClient.post(`/offer-order-items/${id}/decline`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'declineOfferOrderItem error on a call', id, request);
        }
    }
    async calculatePriceForOffer(offerItemId) {
        try {
            const response = await this.httpClient.get(`/offer-order-items/${offerItemId}/price`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'calculatePriceForOffer error on a call', offerItemId);
        }
    }
    /* EMAILS */
    async sendOrderRequestReceivedEmail(request) {
        try {
            const response = await this.httpClient.post('/emails/order-request-received', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendOrderRequestReceivedEmail error on a call', request);
        }
    }
}
exports.OrdersClient = OrdersClient;
